module.exports = __webpack_public_path__ + "static/media/01-click.e2fb44e6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/instructiongifs/01-click.gif
// module id = 258
// module chunks = 0